module.exports = __webpack_public_path__ + "static/img/cooperate.9a8ba25c.png";